import { Controller } from "@hotwired/stimulus"

// Referred from `app/assets/javascripts/transfer_requests.js`
export default class extends Controller {
  static targets = [
    'destinationTerminal',
    'destinationOther',
    'transferByTruck',
    'transferByBarge'
  ];

  ///////////////
  /// Actions ///
  ///////////////

  toggleDestination(event) {
    const destinationType = event.target.value;
    const hideTerminal = destinationType !== 'terminal';
    const hideOther = destinationType !== 'other';

    this.#toggleField(hideTerminal, this.destinationTerminalTarget);
    this.#toggleField(hideOther, this.destinationOtherTarget);
  }

  toggleTransferBy(event) {
    const transferBy = event.target.value;
    const hideTruck = transferBy !== 'truck';
    const hideBarge = transferBy !== 'barge';

    this.#toggleField(hideTruck, this.transferByTruckTarget);
    this.#toggleField(hideBarge, this.transferByBargeTarget);
  }

  ///////////////
  /// Helpers ///
  ///////////////

  #toggleField(hideCondition, field) {
    field.parentElement.classList.toggle('hidden', hideCondition);
    $(field).prop('required', !hideCondition);
    $(field).prop('disabled', hideCondition);
  }
}
